import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions, CountryData } from 'src/app/common-class/questions';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { CustomErrorsHandlerService } from 'src/app/_services/custom-errors-handler.service';
declare var $: any;

@Component({
  selector: 'app-telephone',
  templateUrl: './telephone.component.html',
  styleUrls: ['./telephone.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class TelephoneComponent implements OnInit {
  CountryDatas: CountryData[];
  selectedCountryData: CountryData;
  isLoadControl: boolean = false;

  @Input() question: Questions;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['question'];
    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.question = this.question;
      this.setCountryData();
    }
  }

  constructor(private service: ParticipationDataService,
    private errorsHandlerService: CustomErrorsHandlerService,
    private changeDetect: ChangeDetectorRef
    ) { }

  ngOnInit() {
    this.setCountryData();
  }

  setCountryData() {
    //let url = 'assets/Country.json';
    let url = 'includes/Angular/assets/Country.json?v=09122023'; 
    this.service.GetLocalData(url).subscribe(async (data) => {
      this.CountryDatas = await data.CountryDatas;
      this.CountryDatas.sort((n1, n2) => n1.CountryCode - n2.CountryCode);
      this.selectedCountryData = new CountryData();       

      if (this.question.AnswerText == null || this.question.AnswerText == "") {
        this.geoLocation();

      } else {
        this.splitAnswerText(this.question.AnswerText);
      }

      this.question.SelectedCountry = this.selectedCountryData.Country;
      this.isLoadControl = true;
      this.changeDetect.detectChanges();
    }, error => {
      this.errorsHandlerService.handleError(error);
    });
  }  

  splitAnswerText(text: string) {
    let country = text.split('-');

    if (country != null && country.length > 1) {
      country[0] = country[0].replace('+', '');
      country[0] = country[0].replace(/ /g, '');
      country[0] = this.removeZeroValueOnInitial(country[0]);
      let selectedCountry = this.CountryDatas.find(e => e.CountryCode == country[0]);

      if (selectedCountry != null && selectedCountry != undefined) {
        this.selectedCountryData = selectedCountry;

        if (country.length == 2) {
          this.question.otherAnswer = country[1];          
        } else {
          let phoneNumber: string;
          for (let i = 1; i < country.length; i++) {
            if (i == 1) {
              phoneNumber = country[i];
            } else {
              phoneNumber += country[i];
            }
          }
          this.question.otherAnswer = phoneNumber;
          this.question.AnswerText = this.selectedCountryData.CountryCode + '-' + phoneNumber;
        }

        if (this.checkValidCountryData(this.question.otherAnswer)) {
          this.question.isValid = true;
          this.ChangeAnswersData.emit(this.question);
        } else {
          this.question.otherAnswer = this.phoneNumberFormatSpecificCountry(this.selectedCountryData.CountryCode, this.question.otherAnswer);
          this.question.isValid = false;

          if (country.length > 2) {
            this.ChangeAnswersData.emit(this.question);
          }
        }
      } else {
        // this.question.otherAnswer = this.question.AnswerText;
        // this.geoLocation();
        this.oldDataHandling();
      }
    } else {
      this.oldDataHandling();
    }
  }

  oldDataHandling() {
    this.question.AnswerText = this.question.AnswerText.replace('+', '');
    this.question.otherAnswer = this.question.AnswerText;
    this.selectedCountryData.Country = '';
    this.selectedCountryData.CountryCode = 0;
    this.selectedCountryData.TextLength = 13;
  }

  geoLocation() {
    if (this.service.getGeoLocation() != null && this.service.getGeoLocation().toUpperCase() == 'INTERNAL') {
      this.selectedCountryData = this.CountryDatas.find(e => e.Country == 'India');
    } else {
      let selectedCountry = this.CountryDatas.find(
        e => e.Country == this.service.getGeoLocation());

      if (selectedCountry != undefined && selectedCountry != null) {
        this.selectedCountryData = selectedCountry;
      } else {
        this.selectedCountryData = this.CountryDatas.find(e => e.Country == 'United States');
      }
    }
  }

  removeZeroValueOnInitial(value: string): string {

    if (value.indexOf('0') == 0 && value.length > 1) {
      value = value.substr(1, value.length);
    }

    if (value.indexOf('0') == 0 && value.length > 1) {
      value = this.removeZeroValueOnInitial(value);
    }

    return value;
  }

  dropDownSelectedValue(event: any) {
    let value = event.target.value;
    if (value != null && value != undefined && value != "") {
      this.selectedCountryData = this.CountryDatas.find(e => e.Country == value);
      this.question.SelectedCountry = this.selectedCountryData.Country;
      this.question.AnswerText = null;
      this.question.otherAnswer = null;
      this.question.isValid = false;
      this.question.pageto = this.question.Answers[0].pageto;
      this.ChangeAnswersData.emit(this.question);
    }
  }

  onBlurMethod(value: any) {
    this.question.isValid = false;

    if (this.selectedCountryData.CountryCode == 0) {
      if (value != null && value != "") {
        if (value.length != this.selectedCountryData.TextLength) {
          this.question.isValid = true;
        }else{
          if (this.NumberValidation(value) && value.indexOf(" ") == -1 && value.indexOf(".") == -1) {
            this.question.AnswerText = this.oldPhoneDataFormatter(value);
            this.question.otherAnswer = this.question.AnswerText;
          } else {
            this.question.isValid = true;
            this.question.AnswerText = value;
          }
        }
      } else {
        this.question.AnswerText = null;
      }

      this.question.pageto = this.question.Answers[0].pageto;
      this.ChangeAnswersData.emit(this.question);
      return;
    }    

    if (value != null && value != "") {

      if (this.checkValidCountryData(value)) {
        this.question.isValid = true;
        this.question.AnswerText = this.selectedCountryData.CountryCode + '-' + value;
      } else {
        if (this.NumberValidation(value) && value.indexOf(" ") == -1 && value.indexOf(".") == -1) {
          this.question.AnswerText = this.selectedCountryData.CountryCode + '-' + value;
          this.question.otherAnswer = this.phoneNumberFormatSpecificCountry(this.selectedCountryData.CountryCode, value);
        } else {
          this.question.isValid = true;
          this.question.AnswerText = this.selectedCountryData.CountryCode + '-' + value;
        }
      }
    }
    else {
      this.question.AnswerText = null;
    }
    this.question.pageto = this.question.Answers[0].pageto;
    this.ChangeAnswersData.emit(this.question);
  }

  //CRT - 120208
  checkValidCountryData(value: string): boolean {
    if (this.selectedCountryData.CountryCode == 49 &&
      (value.length < 5 || value.length > this.selectedCountryData.TextLength)) {
      return true;
    } else if (this.selectedCountryData.CountryCode == 41 &&
      (value.length < 9 || value.length > this.selectedCountryData.TextLength)) {
      return true;
    } else if (this.selectedCountryData.CountryCode == 62 &&
      (value.length < 7 || value.length > this.selectedCountryData.TextLength)) {
      return true;
    } else if (this.selectedCountryData.CountryCode == 55 &&
      (value.length < 10 || value.length > this.selectedCountryData.TextLength)) {
      return true;
    } else if ((this.selectedCountryData.CountryCode == 44 ||
      this.selectedCountryData.CountryCode == 60 || this.selectedCountryData.CountryCode == 353) &&
      (value.length < 7 || value.length > this.selectedCountryData.TextLength)) {
      return true;
    } else if ((this.selectedCountryData.CountryCode == 64 ||
      this.selectedCountryData.CountryCode == 82 || this.selectedCountryData.CountryCode == 32) &&
      (value.length < 8 || value.length > this.selectedCountryData.TextLength)) {
      return true;
    } else if (value.length != this.selectedCountryData.TextLength &&
      !(this.selectedCountryData.CountryCode == 49 || this.selectedCountryData.CountryCode == 41 || 
        this.selectedCountryData.CountryCode == 62 || this.selectedCountryData.CountryCode == 55 ||
        this.selectedCountryData.CountryCode == 44 || this.selectedCountryData.CountryCode == 60 ||
        this.selectedCountryData.CountryCode == 353 || this.selectedCountryData.CountryCode == 64 ||
        this.selectedCountryData.CountryCode == 82 || this.selectedCountryData.CountryCode == 32)) {
      return true;
    } else {
      return false;
    }
  }

  onFocus(event: any) {   

    let value = event.target.value;
    this. question.isValid = false;

    if (value != "") {
      value = value.replace("(", '');
      value = value.replace(")", '');
      value = value.replace("-", '');
      value = value.replace(/ /g, '');
      this.question.otherAnswer = value;
    }

    if (this.selectedCountryData.CountryCode == 0) {
      if (value.indexOf('-') >= 0) {
        this.question.otherAnswer = this.removeMultipleHyphen(value);
      }
    }
  }

  removeMultipleHyphen(value: string): string {
    value = value.replace("-", '');

    if (value.indexOf('-') >= 0) {
      value = this.removeMultipleHyphen(value);
    }

    return value;
  }

  NumberValidation(curVal: any) {
    if (curVal != "") {
      if (isNaN(curVal)) {
        return false;
      }
      else {
        return true
      }
    }
  }

  phoneNumberFormatSpecificCountry(countryCode: any, phone: any): string {
    phone = phone.replace(/-/g, '');

    switch (countryCode) {
      case "1":
        return '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        break;
      case "64":
        return phone.substring(0, 4) + ' ' + phone.substring(4, 7) + ' ' + phone.substring(7, 10);
        break;
      case "27":
      case "971":
        return phone.substring(0, 2) + ' ' + phone.substring(2, 5) + ' ' + phone.substring(5, 9);
        break;

      case "32":
        //return phone.substring(0, 3) + ' ' + phone.substring(3, 5) + ' ' + phone.substring(5, 7) + ' ' + phone.substring(7, 9);
        return phone.substring(0, 4) + ' ' + phone.substring(4, 6) + ' ' + phone.substring(6, 8) + ' ' + phone.substring(8, 10);
        break;

      case "39":
        return phone.substring(0, 3) + ' ' + phone.substring(3, 12);
        break;

      case "44":
        return phone.substring(0, 4) + ' ' + phone.substring(4, phone.length);
        break;

      case "49":
        return phone.substring(0, 4) + ' ' + phone.substring(4, phone.length);
        break;

      case "61":
        return phone.substring(0, 3) + ' ' + phone.substring(3, 6) + ' ' + phone.substring(6, 9);
        break;

      case "91":
        return phone.substring(0, 5) + ' ' + phone.substring(5, 10);
        break;

      default:
        return phone;
        break;
    }
  }

  oldPhoneDataFormatter(phone: string): string{
    return phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 9) + '-' + phone.substring(9, 13);
  }
}
